export default {
  "menu.welcome": "Chào mừng",
  "menu.more-blocks": "Thêm khối",
  "menu.home": "Trang chủ",
  "menu.admin": "Quản trị viên",
  "menu.admin.sub-page": "Trang phụ",
  "menu.login": "Đăng nhập",
  "menu.register": "Đăng ký",
  "menu.register-result": "Kết quả đăng ký",
  "menu.dashboard": "Bảng điều khiển",
  "menu.dashboard.analysis": "Phân tích",
  "menu.dashboard.monitor": "Giám sát",
  "menu.dashboard.workplace": "Nơi làm việc",
  "menu.exception.403": "403",
  "menu.exception.404": "404",
  "menu.exception.500": "500",
  "menu.form": "Biểu mẫu",
  "menu.form.basic-form": "Biểu mẫu cơ bản",
  "menu.form.step-form": "Biểu mẫu từng bước",
  "menu.form.step-form.info": "Bước 1 (nhập thông tin chuyển khoản)",
  "menu.form.step-form.confirm": "Bước 2 (xác nhận thông tin chuyển khoản)",
  "menu.form.step-form.result": "Bước 3 (hoàn thành)",
  "menu.form.advanced-form": "Biểu mẫu nâng cao",
  "menu.list": "Danh sách",
  "menu.list.table-list": "Bảng tìm kiếm",
  "menu.list.admin-controller" : "Quản lý admin",
  "menu.list.admin-controller.role-permission" : "Quản lý quyền",
  "menu.list.admin-controller.user-list" : "Danh sách người dùng",
  "menu.list.campaign-config": "Cấu hình chiến dịch",
  "menu.list.schedule": "Lập lịch",
  "menu.list.schedule.task": "Tác vụ",
  "menu.list.schedule.template": "Mẫu",
  "menu.list.config-info-noti": "Cấu hình thông báo",
  "menu.list.customer-data": "Dữ liệu khách hàng",
  "menu.list.dashboard-reports": "Dashboard Reports",
  "menu.list.dashboard-reports.overview": "Tổng quan",
  "menu.list.dashboard-reports.campaigns": "Danh sách Campaigns",
  "menu.list.basic-list": "Danh sách cơ bản",
  "menu.list.card-list": "Danh sách thẻ",
  "menu.list.search-list": "Danh sách tìm kiếm",
  "menu.list.search-list.articles": "Tìm kiếm bài viết",
  "menu.list.search-list.projects": "Tìm kiếm dự án",
  "menu.list.search-list.applications": "Tìm kiếm ứng dụng",
  "menu.profile": "Hồ sơ",
  "menu.profile.basic": "Hồ sơ cơ bản",
  "menu.profile.advanced": "Hồ sơ nâng cao",
  "menu.result": "Kết quả",
  "menu.result.success": "Thành công",
  "menu.result.fail": "Thất bại",
  "menu.exception": "Lỗi",
  "menu.exception.not-permission": "403",
  "menu.exception.not-find": "404",
  "menu.exception.server-error": "500",
  "menu.exception.trigger": "Kích hoạt",
  "menu.account": "Tài khoản",
  "menu.account.center": "Trung tâm tài khoản",
  "menu.account.settings": "Cài đặt tài khoản",
  "menu.account.trigger": "Kích hoạt lỗi",
  "menu.account.logout": "Đăng xuất",
  "menu.editor": "Trình chỉnh sửa đồ họa",
  "menu.editor.flow": "Trình chỉnh sửa luồng",
  "menu.editor.mind": "Trình chỉnh sửa tư duy",
  "menu.editor.koni": "Trình chỉnh sửa Koni",
};
